import React, { useEffect, useRef, useState } from 'react';
import './Myfeatures.css';

const features = [
  {
    title: "Real-Time Emotion & Tone Detection",
    desc: "Live voice analysis detects stress, calm, hesitation, and emotion fully unscripted.",
    icon: "🎙️"
  },
  {
    title: "Physics-Based Trust Engine",
    desc: "Zeta logic + Riemann geometry score trust with no training data  memory-aware & entropy-sensitive.",
    icon: "🧠"
  },
  {
    title: "Privacy & Security First",
    desc: "No voice stored. Encrypted, ephemeral processing with tamper-resistant trust patterns .",
    icon: "🔒"
  },
  {
    title: "Visual Insights & Alerts",
    desc: "Trust timelines + tone deviation alerts help spot credibility shifts in real-time.",
    icon: "📊"
  }
];

const MyFeatures = () => {
  const sectionRef = useRef(null);
  const [animate, setAnimate] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (!sectionRef.current) return;

      const rect = sectionRef.current.getBoundingClientRect();
      if (rect.top < window.innerHeight - 150) {
        setAnimate(true);
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll(); 

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      <div className="feature-intro">
        <h2>What makes our system different from all the others?</h2>
        <p>
          While most systems detect emotion, we go beyond, decoding real-time trust, risk, and credibility using a fusion of emotion, memory, and physics-based collapse models.
          <br />
          <strong>No scripts. No training. Just voice.</strong>
        </p>
      </div>

      <section className="features-section" ref={sectionRef}>
        {features.map((f, idx) => (
          <div className={`feature-box ${animate ? 'animate' : ''}`} key={idx}>
            <div className="feature-icon">{f.icon}</div>
            <h3 className="feature-title">{f.title}</h3>
            <p className="feature-desc">{f.desc}</p>
          </div>
        ))}
      </section>
    </>
  );
};

export default MyFeatures;
